import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpRespSharedItemDetailsList } from '../PdpRespSharedItemDetails/PdpRespSharedItemDetailsList';
import { PdpRespSharedItemDetailsDescription } from '../PdpRespSharedItemDetails/PdpRespSharedItemDetailsDescription';
import { PdpRespSharedItemDetailsAdditionalOptions } from '../PdpRespSharedItemDetails/PdpRespSharedItemDetailsAdditionalOptions';

import { type PdpRespSharedPrintDetails_item$key } from './__generated__/PdpRespSharedPrintDetails_item.graphql';
import { type PdpRespSharedPrintDetails_user$key } from './__generated__/PdpRespSharedPrintDetails_user.graphql';

import styles from './PdpRespSharedPrintDetails.scss';

type Props = {
    item: PdpRespSharedPrintDetails_item$key;
    user: PdpRespSharedPrintDetails_user$key | null | undefined;
    currency: string;
    selectedSkuId?: string | null;
};

const itemFragment = graphql`
    fragment PdpRespSharedPrintDetails_item on Item {
        ...PdpRespSharedItemDetailsDescription_item
        ...PdpRespSharedItemDetailsList_item
        ...PdpRespSharedItemDetailsAdditionalOptions_item
    }
`;

const userFragment = graphql`
    fragment PdpRespSharedPrintDetails_user on User {
        ...PdpRespSharedItemDetailsList_user
        ...PdpRespSharedItemDetailsAdditionalOptions_user
    }
`;

const PdpRespSharedPrintDetails: FC<Props> = ({
    item: itemRef,
    user: userRef,
    currency,
    selectedSkuId,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);

    return (
        <div className={styles.container}>
            <div className={styles.sectionWrapper}>
                {/* Item description */}
                <PdpRespSharedItemDetailsDescription item={item} headerClass={styles.headerText} />
            </div>
            <div className={styles.sectionWrapper}>
                {/* Item details */}
                <PdpRespSharedItemDetailsList
                    item={item}
                    user={user}
                    currency={currency}
                    selectedSkuId={selectedSkuId}
                />
            </div>
            <div className={styles.sectionWrapper}>
                {/* Item customization options */}
                <PdpRespSharedItemDetailsAdditionalOptions
                    user={user}
                    item={item}
                    headerClass={styles.headerText}
                />
            </div>
        </div>
    );
};

export default PdpRespSharedPrintDetails;
